module.exports = function() {
  return new Worker(__webpack_public_path__ + "82526bbc01121aaef896.worker.js");
};